import groq from 'groq'
export const lottieObject = groq`
lottieObject {
  state,
  lottie {
    ...,
    asset-> {
      _id,
      url,
      _type,
      altText,
      description,
      title
    }
  }
}
`